import { render, staticRenderFns } from "./featureRequest.vue?vue&type=template&id=ae9fd69c&scoped=true"
import script from "./featureRequest.vue?vue&type=script&lang=js"
export * from "./featureRequest.vue?vue&type=script&lang=js"
import style0 from "./featureRequest.vue?vue&type=style&index=0&id=ae9fd69c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9fd69c",
  null
  
)

export default component.exports